import type { Discount as ApiDiscount, DiscountType as ApiDiscountType } from '@/gen/api';
import { Discount as DiscountModel, DiscountType } from '@/models/Discount';

const fromApiMap: Record<ApiDiscountType, DiscountType> = {
  fixed_amount: 'fixedAmount',
  percentage: 'percentage',
  bxgy: 'bxgy',
};

const toApiMap: Record<DiscountType, ApiDiscountType> = {
  fixedAmount: 'fixed_amount',
  percentage: 'percentage',
  bxgy: 'bxgy',
};

export const toDiscountType = (apiDiscountType: ApiDiscountType): DiscountType =>
  fromApiMap[apiDiscountType];

export const toDiscount = (apiDiscount: ApiDiscount): DiscountModel => {
  switch (apiDiscount.discountType) {
    case 'fixed_amount':
      return {
        discountType: 'fixedAmount',
        amount: apiDiscount.amount,
        quantityFrom: apiDiscount.quantityFrom,
        quantityTo: apiDiscount.quantityTo,
      };
    case 'percentage':
      return {
        discountType: 'percentage',
        percentage: apiDiscount.percentage!,
        quantityFrom: apiDiscount.quantityFrom,
        quantityTo: apiDiscount.quantityTo,
      };
    case 'bxgy':
      return {
        discountType: 'bxgy',
        buyQuantity: apiDiscount.buyQuantity,
        getQuantity: apiDiscount.getQuantity,
      };
  }
};

export const toApiDiscountType = (discountType: DiscountType): ApiDiscountType =>
  toApiMap[discountType];

export const toApiDiscount = (discount: DiscountModel): ApiDiscount => {
  switch (discount.discountType) {
    case 'fixedAmount':
      return {
        discountType: 'fixed_amount',
        amount: discount.amount,
        quantityFrom: discount.quantityFrom,
        quantityTo: discount.quantityTo,
      };
    case 'percentage':
      return {
        discountType: 'percentage',
        percentage: discount.percentage!,
        quantityFrom: discount.quantityFrom,
        quantityTo: discount.quantityTo,
      };
    case 'bxgy':
      return {
        discountType: 'bxgy',
        buyQuantity: discount.buyQuantity,
        getQuantity: discount.getQuantity,
      };
  }
};
